import React from "react";
import styled from "styled-components";

export default styled.div`
    color: #4E99D6;
    position: absolute;
    top: 17px;
    right: 17px;
    cursor: pointer;
    img {
        width: 20px;
    }
`;